import styled from 'styled-components';

export const Separator = styled.div`
  margin: ${(props) => props.theme.space[6]}px 0;
  border-top: 1px solid ${(props) => props.theme.colors.gray.extraLight};
`;
export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
